import { CardProtectionCoverage } from "src/containers/card-protection/domain/coverage";
import { ReactComponent as InternetFraudIcon } from "src/assets/icons/proteccion-tarjeta/icon_compras_internet.svg";
import { ReactComponent as EmployeesDamageIcon } from "src/assets/icons/hogar/icon_accidentes.svg";
import { ReactComponent as RobberyIcon } from "src/assets/icons/hogar/icon_robo.svg";

const coverages = [
    {
        id: "uso-indebido-tarjetas",
        title: "Uso indebido de tarjetas BCP y otras de crédito",
        shortTitle: "Uso indebido de tarjetas",
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Un extraño utilizó mis tarjetas de crédito y/o débito BCP
                    sin mi consentimiento en establecimientos comerciales y/o en
                    cajeros automáticos.
                </div>
                <div className="coverage-content__section coverage-content__text">
                    O en el caso que un extraño utilizó mis tarjetas de crédito
                    de otros bancos sin mi consentimiento en establecimientos o
                    cajeros automáticos.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Robo o asalto
                    </div>
                    <div className="coverage-content__text bullet">Pérdida</div>
                    <div className="coverage-content__text bullet">Hurto</div>
                    <div className="coverage-content__text bullet">
                        Secuestro
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                    <div className="coverage-content__text bullet important">
                        Constancia con el detalle de cargos indebidos en su
                        tarjeta de crédito, que incluyan fecha, hora, concepto e
                        importe. Debe estar firmada por el ejecutivo responsable
                        de dicha entidad
                    </div>
                    <div className="coverage-content__text bullet important">
                        Constancia debidamente emitida con la firma del
                        ejecutivo responsable, consignando la fecha y hora del
                        bloqueo de la tarjeta afectada
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text warning">
                    * Sólo es necesario incluir estos documentos para el uso
                    indebido de tarjetas que no sean emitidas por el BCP.
                </div>
            </>
        ),
    },
    {
        id: "robo-dinero",
        title: "Robo de dinero retirado por cajero automático",
        shortTitle: "Robo de dinero retirado",
        icon: <RobberyIcon />,
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Retiré dinero de un cajero BCP y al salir me lo robaron.
                </div>
                <div className="coverage-content__section coverage-content__text">
                    Tendrá cobertura por un máximos de 1 hora después del retiro
                    y en un radio de 200 metros.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "robo-compras",
        title: "Robo de compras realizadas",
        shortTitle: "Robo de compras",
        icon: <RobberyIcon />,
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Hice algunas compras con mis tarjetas BCP y al salir me las
                    robaron.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                    <div className="coverage-content__text bullet">
                        Boleta de la compra efectuada
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "fraude-internet",
        title: "Fraude por internet con tarjetas de débito BCP",
        shortTitle: "Fraude por internet",
        icon: <InternetFraudIcon />,
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Me pidieron los datos de mi tarjeta en un e-mail y/o mensaje
                    falso y realizaron operaciones sin mi consentimiento.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">Fraude</div>
                    <div className="coverage-content__text bullet">
                        Página web falsa
                    </div>
                    <div className="coverage-content__text bullet">
                        Cambiazo
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "duplicado-documentos",
        title: "Gastos de duplicado de documentos",
        shortTitle: "Duplicado de documentos",
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Cubrimos el gasto para la obtenciónde duplicado de
                    documentos personales.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Robo o asalto
                    </div>
                    <div className="coverage-content__text bullet">Pérdida</div>
                    <div className="coverage-content__text bullet">Hurto</div>
                    <div className="coverage-content__text bullet">
                        Secuestro
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Comprobantes de gastos relacionados directamente con la
                        reposición de dichos documentos, en caso superen los S/
                        200.00. Si fuera menor a S/ 200.00, se aprueba
                        automáticamente
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "gastos-hospitalizacion",
        title: "Gastos de Hospitalización",
        shortTitle: "Gastos de hospitalización",
        icon: <EmployeesDamageIcon />,
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Recibí un fuerte golpiza cuando me intentaron robar mis
                    tarjetas del BCP, y a consecuencia tuve algunos gastos de
                    hospitalización.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Robo o asalto
                    </div>
                    <div className="coverage-content__text bullet">
                        Secuestro
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                    <div className="coverage-content__text bullet">
                        Informe médico donde se estipulen los días de
                        hospitalización, recetas médicas, solicitud de exámenes
                        y resultados de los mismos
                    </div>
                    <div className="coverage-content__text bullet">
                        Documentos que certifiquen los gastos incurridos por el
                        asegurado durante el periodo de hospitalización
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "muerte-accidental",
        title: "Muerte accidental",
        shortTitle: "Muerte accidental",
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Indemnización por muerte a consecuencia de robo, asalto y/o
                    secuestro con el fin de sustraerle sus tarjetas de crédito
                    y/o débito del BCP.
                </div>
                <div className="coverage-content__section coverage-content__text warning">
                    No olvides comunicar a tus beneficiarios que cuentas con
                    este seguro.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Certificado Médico de Defunción
                    </div>
                    <div className="coverage-content__text bullet">
                        Partida de Defunción
                    </div>
                    <div className="coverage-content__text bullet">
                        Atestado Policial completo, detallando fecha y
                        circunstancias del accidente
                    </div>
                    <div className="coverage-content__text bullet">
                        Protocolo de necropsia completo
                    </div>
                    <div className="coverage-content__text bullet">
                        Declaración de beneficiarios o en caso de no contar con
                        una puedes presentar un acta de sucesión intestada
                        inscrita en registros públicos y/o testamento
                    </div>
                </div>
            </>
        ),
    },
] as CardProtectionCoverage[];

export default coverages;
